<template>
  <b-container
    fluid
    class="supervision-chart"
  >
    <group-componentized-module
      v-if="!!isSensorComponentized"
      :options="sensorInformation"
      :selected-information="selectedInformation"
      @on-change-selected-information="onChangeSelectedInformationHandler"
    />
    <b-row
      align-h="center"
      v-if="showEmptyMessage"
    >
      <s-empty-list :loading="loading"/>
    </b-row>
    <b-row
      v-else
      align-h="center"
      class="supervision-chart__row"
    >
      <default-chart
        class="m-2"
        x-data-manager="dateTime"
        legend-icon="rect"
        chart-id="supervision-sensor"
        :chartData="chartData"
        :loading="loadingChart"
        :remove-outlier.sync="removeChartOutlier"
        :enable-multi-axis.sync="enableChartMultiAxis"
        @toggle-outlier="refreshData(true)"
        @toggle-multi-axis="refreshData(true)"
      />
    </b-row>
  </b-container>
</template>

<script>
import loadingMixin from '@/services/loadingMixin';
import ChartService from '@/domain/services/installation/supervision/sensors/chart';
import eventBus from '@/services/globalEventBus';
import event from '@/domain/events/engineeringModulesHeader';
import defaultChartMixin from '@/domain/mixins/defaultChartMixin';
import DefaultChart from '@/components/charts/DefaultChart';
import { ModuleCategorys } from 'sigma-mappings';
import GroupComponentizedModule from '@/domain/components/installation/supervision/sensors/GroupComponentizedModule';

export default {
  props: {
    isSensorComponentized: {
      type: Boolean,
      default: false,
    },
    category: String,
    selectedInformation: {
      type: Object,
      default: () => ({}),
    },
    sensorInformation: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    DefaultChart,
    GroupComponentizedModule,
  },
  mixins: [
    loadingMixin,
    defaultChartMixin,
  ],
  data: () => ({
    chartData: null,
  }),
  computed: {
    selectedAssetModuleId() {
      const { sensorId } = this.$route.params;
      const { assetModuleId } = this.selectedInformation || {};
      return this.category === ModuleCategorys.COMPONENTIZED
        ? assetModuleId
        : sensorId;
    },
    showEmptyMessage() {
      return this.loading || !this.chartData || !this.chartData.length;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    onChangeSelectedInformationHandler(value) {
      this.$emit('on-change-selected-information', value);
    },
    init() {
      this.refreshData();
      eventBus.on(event.refresh, this.refreshDataEvent, this);
    },
    deinit() {
      eventBus.off(event.refresh, this.refreshDataEvent, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.refreshData());
    },
    refreshData(loadingChart) {
      if (!loadingChart) {
        this.startLoading();
      }
      this.loadingChart = true;
      return ChartService.getData(this.selectedAssetModuleId, this.chartFilters)
      .then((response) => {
        this.chartData = response;
      }).finally(() => {
        this.endLoading();
        this.loadingChart = false;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .supervision-chart
    overflow-x: auto
    overflow-y: hidden
    &__row
      min-width: 600px
</style>
